import { EndOfJourneyScanReadingStateEnum } from '../../../lib/types/enums/end-of-stay-template/end-of-journey-scan.enum'
import { EndOfJourneyScanReadingStatus } from '../../../lib/types/models/end-of-journey-scan/end-of-journey-scan'

// What the secure upload accepts for a scan (backend rule: PDF content type and .pdf extension)
export const isPdf = (file: File) =>
  file.type === 'application/pdf' && file.name.toLowerCase().endsWith('.pdf')

// The reading is paused: the uploaded questionnaires wait until it resumes
export const isReadingPaused = (status?: EndOfJourneyScanReadingStatus | null) =>
  !!status && status.state !== EndOfJourneyScanReadingStateEnum.AVAILABLE

// Why a question was uncertain: "<type label> (<options seen marked>)", no parentheses without options
export const uncertainReason = (typeLabel: string, options: string[]) =>
  options.length > 0 ? `${typeLabel} (${options.join(', ')})` : typeLabel
